import { DefaultService } from '@/services/DefaultService';

export default class AtendimentoPPTService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getPPT(atendimento) {
        return this._http.post(`${this._env}/report/services`, atendimento, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getTableData(atendimento) {
        return this._http.post(`${this._env}/report/services/preview`, atendimento, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}